<div class="bg-color-base-2500 h-100vh">
    <grid-row class="justify-content-center align-content-center h-100">
        <grid-col col="4" mobile="11" class="text-align-center">
            <!-- <ng-icon iconClass="icon-success-white" width="100" height="100" *ngIf="!this.pendingRequest" ></ng-icon> -->
            <ng-icon iconClass="icon-info-green-big" width="100" height="100"></ng-icon>

            <!-- <ng-icon iconClass="icon-info-white" width="100" height="100" *ngIf="this.pendingRequest" ></ng-icon> -->

            <!-- Card Replacement Success -->
            <div *ngIf="this.ReplaceCard">
                <div class="font-500 font-size-32px color-base-2200 line-h-40 mt-40">
                    {{ "YouSuccessfullyReplacement" | translate }}
                </div>
                <div class="font-400 font-size-20px color-base-700 mt-40">
                    {{ "YourNewCardReady" | translate }}
                </div>
            </div>

              <!--Digital Card Replacement Success -->
              <div *ngIf="this.DigiReplaceCard">
                <div class="font-500 font-size-32px color-base-100 line-h-40 mt-40">
                    {{ "YouSuccessfullyDigiReplacement" | translate }}
                </div>
                <div class="font-400 font-size-20px color-base-700 mt-40">
                    {{ "Digi1" | translate }}
                </div>
            </div>


            <!-- Request Physical Card Success -->
           <div  *ngIf="this.PhysicalReq">
            <div class="font-500 font-size-32px color-base-2200 line-h-40 mt-40">
                {{ "YouPhysicalCard" | translate }}
            </div>
            <div class="font-400 font-size-20px color-base-700 mt-40">
                {{ "YourNewCardDelivered" | translate }}
            </div>
           </div>


             <!-- Request Outstanding Balance Letter Success -->
                <div *ngIf="this.letterRequest">
                    <div class="font-500 font-size-32px color-base-2200 line-h-40 mt-40">
                        {{ "YouReceiveLetterEmail" | translate }}
                    </div>
                    <div class="font-400 font-size-20px color-base-700 mt-40">
                        {{ "RequestedLetterTo" | translate }}
                    </div>
                    <div  class="font-400 font-size-20px color-base-100">
                       {{this.Email}}
                    </div>
                    <grid-row class="justify-content-center">
                        <grid-col col="8">
                            <grid-row class="justify-content-between align-item-center mt-24">
                                <grid-col col="auto">
                                    <div class="font-400 font-size-20px color-base-700 mt-40">
                                        {{ "RefId" | translate }} 
                                    </div>
                                </grid-col>
                                <grid-col col="auto">
                                    <div class="font-400 font-size-20px color-base-100 mt-40">
                                        {{this.RefId}}
                                    </div>
                                </grid-col>
                            </grid-row>
                        </grid-col>
                    </grid-row>
                </div>


             <!-- Request Outstanding Balance Letter Success -->
                <div *ngIf="this.pendingRequest">
                    <div class="font-500 font-size-32px color-base-2200 line-h-40 mt-40">
                        {{ "YouRequestLetter" | translate }}
                    </div>
                    <div class="font-400 font-size-20px color-base-700 mt-40">
                        {{ "YourequestProcess" | translate }}
                    </div>
                    <grid-row class="justify-content-center" *ngIf="RefId">
                        <grid-col col="8">
                            <grid-row class="justify-content-between align-item-center mt-24">
                                <grid-col col="auto">
                                    <div class="font-400 font-size-20px color-base-700 mt-40">
                                        {{ "ID" | translate }} 
                                    </div>
                                </grid-col>
                                <grid-col col="auto">
                                    <div class="font-400 font-size-20px color-base-100 mt-40">
                                        {{RefId}}
                                    </div>
                                </grid-col>
                            </grid-row>
                        </grid-col>
                    </grid-row>
                </div>

            <grid-row class="justify-content-center mt-30">
                <grid-col col="8">
                    <button class="btn-dft-border" (click)="Dashboard()">
                        {{ "Done" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
</div>